import { render, staticRenderFns } from "./dashboard_items_list.vue?vue&type=template&id=2cdf0f0b"
import script from "./dashboard_items_list.vue?vue&type=script&lang=js"
export * from "./dashboard_items_list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports